/**
 * This file was generated
 * Do not edit directly
 * See 'fusion-design-system/build-style-dictionary.js' for more info
 */

export const backgroundColorUtilityVariants = () => ({
    "unset": "sui-u-background-unset",
    "app": "sui-u-background-app",
    "app-hover": "sui-u-background-app-hover",
    "surface": "sui-u-background-surface",
    "surface-hover": "sui-u-background-surface-hover",
    "surface-focus": "sui-u-background-surface-focus",
    "surface-selected": "sui-u-background-surface-selected",
    "surface-pressed": "sui-u-background-surface-pressed",
    "surface-raised-1": "sui-u-background-surface-raised-1",
    "surface-raised-2": "sui-u-background-surface-raised-2",
    "solid": "sui-u-background-solid",
    "code": "sui-u-background-code",
    "inverse": "sui-u-background-inverse",
    "meter": "sui-u-background-meter",
    "meter-neutral": "sui-u-background-meter-neutral",
    "meter-critical": "sui-u-background-meter-critical",
    "meter-warning": "sui-u-background-meter-warning",
    "meter-positive": "sui-u-background-meter-positive",
    "meter-info": "sui-u-background-meter-info",
    "meter-primary": "sui-u-background-meter-primary",
    "meter-red": "sui-u-background-meter-red",
    "meter-yellow": "sui-u-background-meter-yellow",
    "meter-green": "sui-u-background-meter-green",
    "meter-blue": "sui-u-background-meter-blue",
    "meter-purple": "sui-u-background-meter-purple",
    "meter-orange": "sui-u-background-meter-orange",
    "meter-cool-gray": "sui-u-background-meter-cool-gray",
    "table-header": "sui-u-background-table-header",
    "table-footer": "sui-u-background-table-footer",
    "table-row": "sui-u-background-table-row",
    "table-row-hover": "sui-u-background-table-row-hover",
    "table-row-striped": "sui-u-background-table-row-striped",
    "table-row-nested": "sui-u-background-table-row-nested",
    "input": "sui-u-background-input",
    "input-hover": "sui-u-background-input-hover",
    "input-focus": "sui-u-background-input-focus",
    "primary": "sui-u-background-primary",
    "primary-solid": "sui-u-background-primary-solid",
    "neutral": "sui-u-background-neutral",
    "info": "sui-u-background-info",
    "critical": "sui-u-background-critical",
    "critical-hover": "sui-u-background-critical-hover",
    "critical-focus": "sui-u-background-critical-focus",
    "critical-pressed": "sui-u-background-critical-pressed",
    "critical-solid": "sui-u-background-critical-solid",
    "warning": "sui-u-background-warning",
    "warning-solid": "sui-u-background-warning-solid",
    "positive": "sui-u-background-positive",
    "positive-solid": "sui-u-background-positive-solid",
});
